import React, { useState } from 'react';
import './AmbassadorRegister.css';

const AmbassadorRegister = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    reason: '',
    school: '',
    faculty: '',
  });

  const [status, setStatus] = useState(null); // { type: 'success' | 'error', message: string }
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus(null);

    // Convert camelCase to expected snake_case
    const payload = {
      full_name: String(formData.fullName),
      email: String(formData.email),
      phone: String(formData.phone),
      location: String(formData.location),
      reason: String(formData.reason),
      school: String(formData.school),
      faculty: String(formData.faculty),
    };

    try {
      const response = await fetch('https://api.myapoti.com/users/ambassadors/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Registration failed.');
      }

      setStatus({ type: 'success', message: 'Thank you for registering as an ambassador!' });
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        location: '',
        reason: '',
        school: '',
        faculty: '',
      });
    } catch (error) {
      setStatus({ type: 'error', message: error.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="ambassador-register">
      <div className="register-container">
        <h1>Join the MyApoti Ambassador Program</h1>
        <p>
          Become a voice of health innovation. Promote MyApoti, connect users to verified pharmacies,
          and enjoy rewards.
        </p>
        <p className="note">
          📣 Whether you're a student or a professional, you're welcome to apply! <br />
          🎉 Register now to take part in the upcoming Ambassador Event happening soon in Calabar.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
          <input
            type="text"
            name="location"
            placeholder="Your Location"
            value={formData.location}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
          <input
            type="text"
            name="school"
            placeholder="Your School / University (optional)"
            value={formData.school}
            onChange={handleChange}
            disabled={isLoading}
          />
          <input
            type="text"
            name="faculty"
            placeholder="Your Faculty or Department (optional)"
            value={formData.faculty}
            onChange={handleChange}
            disabled={isLoading}
          />
          <textarea
            name="reason"
            placeholder="Why do you want to be an ambassador?"
            rows={4}
            value={formData.reason}
            onChange={handleChange}
            required
            disabled={isLoading}
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Submitting...' : 'Submit Application'}
          </button>
        </form>

        {status && (
          <p className={status.type === 'success' ? 'success-message' : 'error-message'}>
            {status.message}
          </p>
        )}
      </div>
    </section>
  );
};

export default AmbassadorRegister;




